import api from './apiService'

// Pedidos pendentes de transferência de hotel (tickets #131-#134 em
// taualegre-gameficacao-app-admin) -- gerados pela cascata de identidade do
// register-family quando nenhum nível bate (ver ADR do parent #129). Rotas
// em /staff/operation/*, GESTAO-only (manager/admin), mesmo gate de Mérito
// pendente.

// `include: 'cases'` traz também os casos sem conta/hotel pedidos (revisão de identidade, conflito de estadia); sem ele o
// backend devolve só a forma antiga (transferência / atualização de família).
export const listPendingHotelTransferRequests = ({ page = 1, limit = 20, include } = {}) =>
  api.get('/staff/operation/hotel-transfer-requests/pending', { params: { page, limit, ...(include ? { include } : {}) } })

// Histórico do caso (quem fez o quê e quando), do mais antigo para o mais novo.
export const listHotelTransferRequestEvents = (id) =>
  api.get(`/staff/operation/hotel-transfer-requests/${id}/events`)

// Só a contagem -- usada pelo indicador de notificação da sidebar (polling
// periódico, ver docs/adr/0001-sidebar-notification-indicator.md).
export const countPendingHotelTransferRequests = () =>
  api.get('/staff/operation/hotel-transfer-requests/pending-count')

// "Resolver" é só uma flag de status -- a transferência de hotel_id em si
// continua acontecendo pela edição manual de Responsável (ResponsaveisView),
// não por uma ação nova.
// `note` (opcional, 3 a 500 caracteres) fica registrada no histórico com o usuário da gestão.
const withNote = (note) => (note ? { note } : undefined)

export const resolveHotelTransferRequest = (id, note) =>
  api.post(`/staff/operation/hotel-transfer-requests/${id}/resolve`, withNote(note))

// Gestor aplica SÓ filhos e responsáveis do pré-cadastro na conta (não mexe em hotel/estadia/telefone).
export const applyHotelTransferFamily = (id, note) =>
  api.post(`/staff/operation/hotel-transfer-requests/${id}/apply-family`, withNote(note))

// Gestor recusa o pedido: nada é alterado e o pré-cadastro é apagado.
export const rejectHotelTransferRequest = (id, note) =>
  api.post(`/staff/operation/hotel-transfer-requests/${id}/reject`, withNote(note))
